import {
  paths,
  supportEmailResendResponseSchema,
  type SupportEmailResendResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/** 重发结果与当前配置一起返回，业务结果仍是成功响应。 */
export const resendSupportEmailOperation = "settings.verify-support-email";

export type ResendSupportEmailOperation = typeof resendSupportEmailOperation;

export type ResendSupportEmailFailure =
  BackendFailure<ResendSupportEmailOperation>;

export function resendSupportEmail(
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<SupportEmailResendResponse, ResendSupportEmailFailure> {
  return requestBackendResult({
    fetch: options.fetch,
    method: "POST",
    operation: resendSupportEmailOperation,
    parse: (payload) => supportEmailResendResponseSchema.parse(payload),
    path: paths.settingsSupportEmail,
    signal: options.signal,
  });
}
